import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchSponsorshipDetail, 
  bookSponsorshipSlot 
} from "./sponsorshipThunks";

const initialState = {
  loading: false,
  details: null,
  booking: null,
  error: null,
};

const sponsorshipSlice = createSlice({
  name: "sponsorship",
  initialState,
  reducers: {
    resetBooking(state) {
      state.booking = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // =================== FETCH DETAIL ===================
      .addCase(fetchSponsorshipDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSponsorshipDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload?.data || null;
      })
      .addCase(fetchSponsorshipDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =================== BOOK SLOT ===================
      .addCase(bookSponsorshipSlot.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bookSponsorshipSlot.fulfilled, (state, action) => {
        state.loading = false;
        state.booking = action.payload?.data || null;
      })
      .addCase(bookSponsorshipSlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBooking } = sponsorshipSlice.actions;

export default sponsorshipSlice.reducer;
